import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheWelcome = _resolveComponent("TheWelcome")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_TheWelcome)
  ]))
}